/*
  Define display configuration options at region, brand, or both.
  
  Use this as an alternative to the BE data-configuration json, for small/visual brand requests.
  We don't want to overload the BE provided config with 'non-essential' display configs.

  While it might not be considered a best practice, this solution will speed up delivery efforts for some of these display discrepancy requests.
  Always decided with the team, if a new feature flag is more suitable to be added here.
*/

export type DisplayConfig = {
  showUPSPriceAsFreeIfZero?: boolean,
  showDisabledGiftCardMessage?: boolean,
  disabledGiftCardMessages?: string[],
};

export const defaultDisplayConfig: DisplayConfig = {
  showDisabledGiftCardMessage: false,
  showUPSPriceAsFreeIfZero: true,
};

const RegionConfig = new Map<string, DisplayConfig>();
const BrandConfig = new Map<string, DisplayConfig>();
const BrandLocaleConfig = new Map<string, DisplayConfig>();

export const getDisplayConfig = (brandName: string, region: string): DisplayConfig => {
  const regionConfig = RegionConfig.get(region?.toLowerCase());
  const brandConfig = BrandConfig.get(brandName?.toLowerCase());
  const brandLocaleConfig = BrandLocaleConfig.get(`${brandName}-${region}`.toLowerCase());

  const displayConfig = {
    ...defaultDisplayConfig,
    ...regionConfig,
    ...brandConfig,
    ...brandLocaleConfig,
  };

  return displayConfig;
};

BrandLocaleConfig.set('esteelauder-us', {
  showUPSPriceAsFreeIfZero: false,
});

BrandLocaleConfig.set('maccosmetics-us', {
  disabledGiftCardMessages: [
    'We are currently upgrading our gift card platform to better serve you.',
    'From August 4th, 9pm EST through August 11th, gift card purchases, redemptions, refunds and balance-related services will be temporarily unavailable.',
    'Any existing gift card balances remain secure and will be available once the upgrade is complete.<br/>We apologize for the inconvenience and appreciate your patience.',
  ],
  showDisabledGiftCardMessage: true,
});
